import { render, staticRenderFns } from "./StaffSale.vue?vue&type=template&id=3788d363&"
import script from "./StaffSale.vue?vue&type=script&lang=js&"
export * from "./StaffSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports